import React from 'react'

export default function GMBSVG(){
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0C7.16406 0 0 7.16406 0 16C0 24.8359 7.16406 32 16 32C24.8359 32 32 24.8359 32 16C32 7.16406 24.8359 0 16 0ZM24.7156 23.5433L19.0998 27.0585C19.0998 27.0585 17.6109 25.5532 16.0396 22.8541C14.4666 25.5548 12.9761 27.0635 12.9761 27.0635L7.36026 23.5482L9.00247 17.85C6.20115 17.1014 4.49629 16.1715 4.49629 16.1715L6.31987 9.80214H11.3223L12.7222 4.94147L14.7815 4.94476L19.3553 4.93652L20.7568 9.80049H25.6834L27.507 16.1698C27.507 16.1698 25.8318 17.0833 23.0717 17.8285L24.7172 23.5416L24.7156 23.5433ZM16.9893 11.0322C15.5169 11.0322 14.3215 12.2259 14.3215 13.6999C14.3215 15.1739 15.5153 16.3677 16.9893 16.3677C18.4633 16.3677 19.657 15.1739 19.657 13.6999C19.657 12.2259 18.4633 11.0322 16.9893 11.0322Z" fill="white"/>
    </svg>
    
  )
}

